
import { Component, effect, EventEmitter, Input, NgZone, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EntityBase } from '@app/common-codes/_models/EntityBase';
import { IEntityMetaData, IMetaProprety } from '@app/common-codes/_models/IEntityMetaData';
import { GenericComponent } from '@app/common-codes/components/_base/GenericComponent';
import { OnReadyDirective } from '@app/common-codes/components/directives/OnReadyDirective';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { DataService } from '@app/common-codes/services/DataService';
import { EntityConstructor } from '@app/common-codes/services/DependecyInjection.provider';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { ValidationCodeEntity } from '@app/models/qr-code/verificationCode.model';


@Component({
  selector: 'app-validation-code',
  standalone: true,
  imports: [FormsModule, TranslatePipe, OnReadyDirective],
  templateUrl: './validation-code.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class ValidationCodeComponent extends GenetricDetailComponent<ValidationCodeEntity> {

  override Editable: boolean = true;
  override ComponentEntityClass: EntityConstructor<ValidationCodeEntity> = ValidationCodeEntity;
  override entityMetaData: IEntityMetaData = ValidationCodeEntity.getMetaData();
  override Skin: IStaticStylesConfig = MatwinsSkins.QrCode1;
  override isModal: boolean = true;
  public override get RequiredPermissions(): string[] {
    return [];
  }
  public override get HasRequiredPermissions(): boolean {
    return true;
  }

  @Output() $codeGenerated: EventEmitter<void> = new EventEmitter<void>();
  @Output() $dataChanged: EventEmitter<ValidationCodeEntity> = new EventEmitter<ValidationCodeEntity>();
  @Output() $validationSuccess: EventEmitter<any> = new EventEmitter<any>();
  /**
   *
   */
  constructor(translationService: TranslationService,
    route: ActivatedRoute,
    router: Router,
    validationService: GenericValidationService,
    ngZone: NgZone,
  ) {
    super(route, router, translationService, validationService, ngZone);
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();

    this.focusOnInputElement('emailOrPhoneInput');  
  }

  override parseToEntityInstance(): void {
    if (this.EntityInstance && this.editingEntity()) {
      Object.assign(this.EntityInstance, this.editingEntity());
    }
  }
  override getEmptyEntity(): ValidationCodeEntity {
    return new ValidationCodeEntity();
  }

  onFieldChange() {
    if (this.editingEntity()) {
      this.$dataChanged.emit(this.editingEntity()!);
    }
  }

  async generateVerificationCode() {
    this.$codeGenerated.emit();

    this.focusOnInputElement('verificationCode');  //emailOrPhoneInput

    let currentValidationCode = this.editingEntity(); 

    if (currentValidationCode) {
      let identificationData = `${currentValidationCode.identificationData}`;

      currentValidationCode.email = undefined; 
      currentValidationCode.phoneNumber = undefined;

      if (identificationData.indexOf('@') > -1) {
        currentValidationCode.email = currentValidationCode.identificationData;
      }
      else {
        currentValidationCode.phoneNumber = currentValidationCode.identificationData;
      }


      currentValidationCode.messages['emailBody'] = this.translationService.instant('messages.qrcode.validation-code.email-body');
      currentValidationCode.messages['emailSubject'] = this.translationService.instant('messages.qrcode.validation-code.email-subject');
      currentValidationCode.messages['smsBody'] = this.translationService.instant('messages.qrcode.validation-code.sms-body');

      const value = await this.dataService.execute<ValidationCodeEntity>('POST', 'generateCode', currentValidationCode);
      this.editingEntity.set(value);
    }
    else {
      // Invalid input format
      console.error('Invalid format for identification field');
      return;
    }
  }
  //emailOrPhoneInput   //

  private focusOnInputElement(id:string) {
    const targetInputElmt = document.getElementById(id) as HTMLInputElement;
    if (targetInputElmt) {
      targetInputElmt.value = "";
      targetInputElmt.focus();
    }
  }

  async validateCode() {
    let currentValidationCode = this.editingEntity();
    if (currentValidationCode) {
      const authenticatedUser = await this.dataService.execute<any>('POST', 'validateCode', currentValidationCode);
      if (authenticatedUser) {
        this.$validationSuccess.emit(authenticatedUser);
      } else {
        console.error('Code validation failed.');
      }
    }
  }
}

